import { useAsyncCollectionOptions } from "@easybiz/component";
import {
  useCheckoutEditOrder,
  useCheckoutService,
  useCheckoutServiceTypes,
  useClientDate,
  useClientStateSetter,
  useUserBusinessCode
} from "@easybiz/component-shared";
import { useEffect } from "react";

export default function () {
  const service = useCheckoutService();
  const businessCode = useUserBusinessCode();
  const editOrder = useCheckoutEditOrder();
  const date = useClientDate();
  const serviceTypes = useCheckoutServiceTypes();
  const setState = useClientStateSetter();
  const { options } = useAsyncCollectionOptions({
    serviceId: service?.id,
    businessCode,
    date,
    orderId: editOrder?.id,
    serviceTypes,
    combine: true,
  });

  useEffect(() => {
    setState({ collectionOptions: options });
  }, [options]);
}
